import { ImportMap } from "@app/shared/resources/class-importer-exporter.service";
import { CommandHelper, CommandProviders } from "./command";
import { ServiceCommand, ServiceCommandData } from "./service-command";

export interface ServicePropertyCommand extends ServiceCommand {
    propertyValue: string | number;
    propertyName?: string;
}

/* eslint-disable @typescript-eslint/naming-convention */
export interface ServicePropertyCommandData extends ServiceCommandData {
    uid: string;
    cpid: string;
    property_value: string | number;
    property_name?: string;
}
/* eslint-enable @typescript-eslint/naming-convention */

export const isServiceProperty = (command: ServiceCommand): command is ServicePropertyCommand =>
    command.commandType === CommandProviders.SERVICE_PROPERTY;

export class ServicePropertyCommandHelper extends CommandHelper {
    static readonly importMap: ImportMap<ServicePropertyCommand, ServicePropertyCommandData> = [
        { i: "name", o: "name" },
        { i: "command_id", o: "commandId" },
        { i: "command_type", o: "commandType" },
        { i: "uid", o: "serviceUid" },
        { i: "cpid", o: "controlPointId" },
        { i: "property_name", o: "propertyName" },
        { i: "property_value", o: "propertyValue" },
    ];

    static fromCHObject(command, steps?): ServicePropertyCommand {
        return {
            name: command[this.importMap[0].i],
            commandId: command[this.importMap[1].i],
            commandType: command[this.importMap[2].i],
            serviceUid: command[this.importMap[3].i],
            controlPointId: command[this.importMap[4].i],
            propertyName: command[this.importMap[5].i],
            propertyValue: command[this.importMap[6].i],
            service: null,
        };
    }

    static getDefault(service): ServicePropertyCommand {
        return {
            name: "Do Something",
            commandId: null,
            commandType: CommandProviders.SERVICE_PROPERTY,
            serviceUid: service.instanceId,
            controlPointId: null,
            propertyName: null,
            propertyValue: null,
            service,
        };
    }

    getCommandName(command) {
        // stub for inheritance
    }
}
